<template>
  <div class="alice-shell theme-turquoise">
    <TopBar class="alice-shell__topbar">
      <template #breadcrumb>
        <a
          href="#"
          class="alice-tb-crumb"
          @click.prevent="$router.push('/projects')"
          >Projects</a
        >
        <span class="alice-tb-sep">›</span>
        <span class="alice-tb-crumb alice-tb-crumb--current">Admin</span>
      </template>
    </TopBar>

    <Sidebar class="alice-shell__sidebar" variant="rail" active-key="admin" />

    <AdminSubSidebar class="alice-shell__subsidebar" />

    <main class="alice-shell__main">
      <router-view v-slot="{ Component, route }">
        <transition name="slide-fade" mode="out-in">
          <component :is="Component" :key="route.path" />
        </transition>
      </router-view>
    </main>
  </div>
</template>

<script>
import TopBar from "@/components/alice/TopBar.vue";
import Sidebar from "@/components/alice/Sidebar.vue";
import AdminSubSidebar from "@/components/alice/AdminSubSidebar.vue";

export default {
  name: "AdminPage",
  components: { TopBar, Sidebar, AdminSubSidebar },
};
</script>

<style scoped lang="scss">
.alice-shell {
  display: grid;
  grid-template-rows: 56px 1fr;
  grid-template-columns: 56px 280px 1fr;
  height: 100vh;
  width: 100%;
  background: var(--bg-muted);
  font-family: var(--font-body);
  color: var(--fg-1);
  overflow: hidden;
}
.alice-shell__topbar {
  grid-column: 1 / -1;
  grid-row: 1;
}
.alice-shell__sidebar {
  grid-column: 1;
  grid-row: 2;
}
.alice-shell__subsidebar {
  grid-column: 2;
  grid-row: 2;
}
.alice-shell__main {
  grid-column: 3;
  grid-row: 2;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  background: var(--vp-white);
}

.alice-tb-crumb {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: var(--vp-grijs-80);
  white-space: nowrap;
}
.alice-tb-crumb:hover {
  color: var(--vp-white);
}
.alice-tb-crumb--current {
  color: var(--vp-white);
  text-transform: none;
  letter-spacing: 0.04em;
}
.alice-tb-sep {
  color: var(--vp-grijs-160);
  font-weight: 400;
}

@media (max-width: 1279px) {
  .alice-shell {
    grid-template-columns: 56px 240px 1fr;
  }
}
</style>
